import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { ChatBotIcon } from '@shared/custom-icons';
import { SystemStyleObject } from '@mui/system';
import { useSharedTFunction } from '@shared/i18n';

interface Props {
  onClick: () => void;
  sx?: SystemStyleObject;
}

export const ChatbotSquareTrigger = React.forwardRef<HTMLDivElement, Props>(
  ({ onClick, sx = {}, ...props }, ref) => {
    const t = useSharedTFunction();
    return (
      <Box
        display="flex"
        width={46}
        ref={ref}
        justifyContent="end"
        sx={{
          '&:hover button': {
            transform: 'translateX(0px)',
            boxShadow: '0px 12px 32px rgba(0,0,0,0.3)',
          },
          ...sx,
        }}
        {...props}
      >
        <ButtonBase
          onClick={onClick}
          sx={{
            zIndex: ({ zIndex }) => zIndex.modal + 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            width: 46,
            p: 1,
            pr: 3,
            borderBottomLeftRadius: '4px',
            borderTopLeftRadius: '4px',
            color: 'white',
            bgcolor: 'primary.main',
            boxShadow: 'none',
            transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
            transform: 'translateX(16px)',
          }}
        >
          <Typography sx={{ writingMode: 'vertical-rl' }}>{t('shared.chatbot.askAda')}</Typography>
          <ChatBotIcon sx={{ width: 38, height: 38 }} />
        </ButtonBase>
      </Box>
    );
  }
);
